import { Box } from '@chakra-ui/react';
import { FC } from 'react';

import { TextField, Txt } from '@app/components/common';
import { Form } from '@app/components/common/form/form';
import { FieldComponentProps } from '@app/components/common/types';

import { MasterOutletFormInstance } from '../types';
import { inputStyle } from './previous-value';

export const ContactFields: FC<FieldComponentProps<string> & {
  field: keyof MasterOutletFormInstance
  instance?: Partial<MasterOutletFormInstance>,
  origin?: Partial<MasterOutletFormInstance>
}> = ({ label, value, onChange, field, origin, instance, disabled, readOnly }) => {
  const [contact, phone, email] = value?.split('|') || [];
  const [origContact, origPhone, origEmail] = ((origin?.[field] || '') as string).split('|');
  const [instContact, instPhone, instEmail] = ((instance?.[field] || '') as string).split('|');

  const diffContact = origin && instContact !== origContact ? origContact : undefined;
  const diffPhone = origin && instPhone !== origPhone ? origPhone : undefined;
  const diffEmail = origin && instEmail !== origEmail ? origEmail : undefined;

  return (<>
    <Form.Spacer span={{ md: 6 }}>
      <Box __css={diffContact ? inputStyle : undefined}>
        <TextField 
          id='contact'
          label={`${label} - ФИО`}      
          value={contact || ''}
          disabled={disabled}
          readOnly={readOnly}
          onChange={(val) => {
            const [_, phone, email] = value?.split('|') || [];
            onChange(
              `${val || ''}|${phone || ''}|${email || ''}`
            );
          }}
        />
        {diffContact && <Box display="flex" flexDirection="row">
          <Txt color='gray.500'>Текущее значение:&nbsp;</Txt>
          <Txt color='brand.500'>{diffContact}</Txt>
        </Box>}
      </Box>
    </Form.Spacer>
    <Form.Spacer span={{ md: 3 }}>
      <Box __css={diffPhone ? inputStyle : undefined}>
        <TextField 
          id='phone'
          label='Телефон' 
          value={phone || ''}
          disabled={disabled}
          readOnly={readOnly}
          onChange={(val) => {
            const [fio, _, email] = value?.split('|') || [];
            onChange(
              `${fio || ''}|${val || ''}|${email || ''}`
            );
          }}
        />
        {diffPhone && <Box display="flex" flexDirection="row">
          <Txt color='gray.500'>Текущее значение:&nbsp;</Txt>
          <Txt color='brand.500'>{diffPhone}</Txt>
        </Box>}
      </Box>
    </Form.Spacer>
    <Form.Spacer span={{ md: 3 }}>
      <Box __css={diffEmail ? inputStyle : undefined}>
        <TextField 
          id='email'
          label='Email' 
          value={email || ''}
          disabled={disabled}
          readOnly={readOnly}
          onChange={(val) => {
            const [fio, phone] = value?.split('|') || [];
            onChange(
              `${fio || ''}|${phone || ''}|${val || ''}`
            );
          }}
        />
        {diffEmail && <Box display="flex" flexDirection="row">
          <Txt color='gray.500'>Текущее значение:&nbsp;</Txt>
          <Txt color='brand.500'>{diffEmail}</Txt>
        </Box>}
      </Box>
    </Form.Spacer>
  </>);
};
